import { cn } from '@shared/utils/utils';

export interface SpinnerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'light';
}

const SIZES = {
  sm: { spinnerSize: '24px', cubeSize: '10px', gap: '4px', radius: '2px' },
  md: { spinnerSize: '40px', cubeSize: '16px', gap: '8px', radius: '3px' },
  lg: { spinnerSize: '56px', cubeSize: '24px', gap: '8px', radius: '4px' },
} as const;

const DURATION = '1s';

export const Spinner = ({ className, size = 'md', variant }: SpinnerProps) => {
  const s = SIZES[size];
  const cssVars = {
    '--spinner-size': s.spinnerSize,
    '--cube-size': s.cubeSize,
    '--spinner-gap': s.gap,
    '--cube-radius': s.radius,
    '--spinner-duration': DURATION,
  } as React.CSSProperties;

  const isForceLight = variant === 'light';

  const cubeColors = isForceLight
    ? ['bg-lines', 'bg-card-border', 'bg-hover-press']
    : [
        'bg-lines dark:bg-lines',
        'bg-card-border dark:bg-card-border',
        'bg-hover-press dark:bg-hover-press',
      ];

  return (
    <div
      className={cn('flex items-center justify-center p-6', className)}
      data-testid="spinner"
    >
      <div className="spinner-container" style={cssVars}>
        <div className={cn('spinner-cube-seq', cubeColors[0])} />
        <div className={cn('spinner-cube-seq', cubeColors[1])} />
        <div className={cn('spinner-cube-seq', cubeColors[2])} />
      </div>
    </div>
  );
};
